
export default {
    props: {
        visible: {//是否可见
            type: Boolean,
            default: false
        },
        multiple: {//允许多选
            type: Boolean,
            default: true
        },
        orgKey: {//指定机构，如果指定该参数，则仅仅加载该机构及其子机构,
            type: String,
            default: null
        },
        orgCode:{//指定机构，如果指定该参数，则仅仅加载该机构及其子机构
            type: String,
            default: null
        },
        selections:{
            type: Array,
            default(){
                return [];
            }
        }
    },
    watch: {
        visible(){
            const me = this, picker = me.$refs['org-picker'];
            console.log(picker); 
            if(me.visible){
                picker && picker.initSelection();
            }
        }
    },
    methods: {
        cancel(){
            this.$emit('callback', null, this);
            this.$emit('close', null, this);
        },
        shClose(){//关闭时激活
            const me = this, picker = me.$refs['org-picker'];
            me.$emit('callback', picker.getOrg());
            me.$emit('selected', picker.getOrg());
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/org/dialog/src/dialog.js